import React, { Component } from 'react';

class Rewards extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="rewards">
        <div className="rewards__rewardsContainer">
          <div className="rewards__rewardsContainer__content">
            <div className="rewards__rewardsContainer__content__decorations">
              <div className="top-border" />
              <div className="clearfix" />
              <div className="rewards__rewardsContainer__header">
                <h3>
                  <span className="header">MSI</span> Rewards
                </h3>
                <p>Additional savings made easy!</p>
              </div>
              <div className="bottom-border" />
              <div className="clearfix" />
            </div>
            <h4>
              Start Earning Rewards Today – and your next prescription could be
              free.
            </h4>
            <p>
              You can earn valuable MSI Reward credits simply by sharing with
              others the news of incredibly affordable prescription drugs that
              MSI Drugstore offers.
            </p>
            <br />
            <p>
              Every time you refer a new customer to us, you will earn a $20.00
              credit towards your next order. Not only will you save $20, the
              person that you are referring will save $20 on their first order
              over $100. That’s an incredible $20 for you and $20 for the person
              you refer!
            </p>
            <br />
            <p>
              There is no limit to how many MSI Reward credits you can collect.
              Many of our customers have reduced their medication costs just by
              referring other people. MSI Reward credits are redeemable in
              increments of $20.00. You can redeem all of your rewards at one
              time, or save them up for future orders
            </p>
          </div>

          <div className="rewards__rewardsContainer__content">
            <div className="rewards__rewardsContainer__header">
              <h3>Program Rules</h3>
            </div>
            <h4>How To Get Rewards</h4>
            <p>
              For you to be eligible to earn a Rewards credit with MSI Rewards,
              the customer you refer (the Prospect) must (i) have been referred
              by you to MSI , (ii) be a first time customer of MSI (iii) order
              $100 or more worth of medications. A Prospect that satisfies all
              of the above criteria shall be deemed to be a “Qualified Referral”
              and you will be eligible to receive a $20.00 credit towards future
              purchases (“Reward”).
            </p>
            <br />
            <p>
              Prospects must voluntarily elect to participate in the MSI Rewards
              program and to order medications from MSI.
            </p>
            <br />
            <p>
              If a customer is referred to MSI from more than one source, MSI in
              its sole discretion will determine the chronologically oldest
              dated referral in its possession and that referring party shall be
              entitled to receive the Reward credit.
            </p>
            <br />
            <p>
              Awarded credits will be reversed if a Prospect cancels or returns
              an order (or a portion of their order) for unsatisfactory reasons,
              thus reversing their position as a “Qualified Referral”.
            </p>
          </div>
          <div className="rewards__rewardsContainer__content">
            <div className="rewards__rewardsContainer__header">
              <h3>Using Your Rewards</h3>
            </div>
            <h4>
              Rewards credit is redeemable at MSI for prescription drug
              purchases only.
            </h4>
            <p>
              MSI must be notified at the time of placing your order that you
              wish to redeem part or all of your credit on that order.
            </p>
            <br />
            <p>Credit is redeemable in full $20.00 increments only.</p>
            <br />
            <p>Rewards credit may not be redeemed for cash.</p>
            <br />
            <p>
              Awarded credits will be reversed if a Prospect cancels or returns
              an order (or a portion of their order) for unsatisfactory reasons,
              thus reversing their position as a “Qualified Referral”.
            </p>
          </div>
          <div className="rewards__rewardsContainer__content">
            <div className="rewards__rewardsContainer__header">
              <h3>Program Disclaimer</h3>
            </div>
            <p>
              Participation in the MSI Rewards program is subject to any terms
              and conditions, rules, regulations, policies and procedures that
              MSI may, at its discretion, modify or adopt from time-to-time.
            </p>
            <br />
            <p>
              MSI reserves the right to terminate the MSI Rewards program or
              change the program rules, benefits, conditions of participation,
              in whole or in part, at any time, with or without notice. In the
              event of termination, you will be entitled to receive any and all
              Rewards accrued prior to the termination date.
            </p>
            <br />
            <p>
              Failure to follow the MSI Rewards program rules or any
              misrepresentation of any information furnished to MSI Drugstore
              may result in the cancellation of the number of Qualified
              Referrals or Rewards.
            </p>
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default Rewards;



// WEBPACK FOOTER //
// ./src/components/Rewards/Rewards.js